(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  function getPageContext(root) {
    var params = new URLSearchParams(window.location.search);
    return {
      shopify_customer_id: root.dataset.customerId || null,
      email: root.dataset.customerEmail || params.get("email") || null,
      shopify_order_id: params.get("order_id") || null,
      shopify_order_name: params.get("order_name") || params.get("order") || null,
      source: root.dataset.source || "online_booster_system_survey",
      page_url: window.location.href
    };
  }

  ready(function () {
    var roots = document.querySelectorAll("[data-ertima-survey]");
    roots.forEach(function (root) {
      if (root.dataset.ready === "1") return;
      root.dataset.ready = "1";

      var apiBase = (root.dataset.apiBase || "").replace(/\/$/, "");
      var choices = root.querySelectorAll("[data-survey-choice]");
      var comment = root.querySelector("[data-survey-comment]");
      var status = root.querySelector("[data-survey-status]");
      var reportForm = root.querySelector("[data-bug-report-form]");
      var reportStatus = root.querySelector("[data-report-status]");
      var reportEmail = root.querySelector("[data-report-email]");
      var reportOrder = root.querySelector("[data-report-order]");

      function setStatus(message, type) {
        if (!status) return;
        status.textContent = message || "";
        status.classList.toggle("is-success", type === "success");
        status.classList.toggle("is-error", type === "error");
      }

      function setReportStatus(message, type) {
        if (!reportStatus) return;
        reportStatus.textContent = message || "";
        reportStatus.classList.toggle("is-success", type === "success");
        reportStatus.classList.toggle("is-error", type === "error");
      }

      function setDisabled(disabled, selectedButton) {
        choices.forEach(function (button) {
          button.disabled = disabled;
          button.classList.toggle("is-selected", button === selectedButton);
        });
      }

      function getField(selector) {
        var field = root.querySelector(selector);
        return field ? field.value.trim() : "";
      }

      function setReportDisabled(disabled) {
        if (!reportForm) return;
        reportForm.querySelectorAll("input, textarea, select, button").forEach(function (field) {
          field.disabled = disabled;
        });
      }

      if (reportEmail && !reportEmail.value && root.dataset.customerEmail) {
        reportEmail.value = root.dataset.customerEmail;
      }
      if (reportOrder) {
        var orderFromUrl = new URLSearchParams(window.location.search).get("order") || new URLSearchParams(window.location.search).get("order_name") || "";
        if (orderFromUrl) reportOrder.value = orderFromUrl;
      }

      choices.forEach(function (button) {
        button.addEventListener("click", function () {
          if (!apiBase) {
            setStatus("API-Basispfad fehlt.", "error");
            return;
          }

          var choice = button.dataset.surveyChoice;
          var payload = Object.assign(getPageContext(root), {
            preference: choice,
            comment: comment ? comment.value : ""
          });

          setDisabled(true, button);
          setStatus("Antwort wird gespeichert ...", "");

          fetch(apiBase + "/my_packs_feedback", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "omit",
            body: JSON.stringify(payload)
          }).then(function (response) {
            return response.json().catch(function () { return {}; }).then(function (json) {
              if (!response.ok || !json.success) {
                throw new Error(json.message || "Antwort konnte nicht gespeichert werden.");
              }
              setStatus("Danke, deine Antwort wurde gespeichert.", "success");
            });
          }).catch(function (error) {
            setDisabled(false, null);
            setStatus(error.message || "Antwort konnte nicht gespeichert werden.", "error");
          });
        });
      });

      if (reportForm) {
        reportForm.addEventListener("submit", function (event) {
          event.preventDefault();
          if (!apiBase) {
            setReportStatus("API-Basispfad fehlt.", "error");
            return;
          }

          var orderReference = getField("[data-report-order]");
          var context = getPageContext(root);
          var payload = Object.assign(context, {
            email: getField("[data-report-email]") || context.email,
            report_type: getField("[data-report-type]"),
            page_area: getField("[data-report-page-area]"),
            title: getField("[data-report-title]"),
            description: getField("[data-report-description]"),
            expected: getField("[data-report-expected]"),
            device: getField("[data-report-device]"),
            browser: navigator.userAgent || "",
            screenshot_url: getField("[data-report-screenshot]")
          });
          if (orderReference) {
            if (orderReference.charAt(0) === "#") {
              payload.shopify_order_name = orderReference;
            } else {
              payload.shopify_order_id = orderReference;
            }
          }

          setReportDisabled(true);
          setReportStatus("Meldung wird gespeichert ...", "");

          fetch(apiBase + "/my_packs_bug_report", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "omit",
            body: JSON.stringify(payload)
          }).then(function (response) {
            return response.json().catch(function () { return {}; }).then(function (json) {
              if (!response.ok || !json.success) {
                throw new Error(json.message || "Meldung konnte nicht gespeichert werden.");
              }
              reportForm.reset();
              if (reportEmail && payload.email) reportEmail.value = payload.email;
              setReportStatus(json.message || "Danke, deine Meldung wurde gespeichert.", "success");
            });
          }).catch(function (error) {
            setReportStatus(error.message || "Meldung konnte nicht gespeichert werden.", "error");
          }).finally(function () {
            setReportDisabled(false);
          });
        });
      }
    });
  });
})();
